// React&NextJS
import React from 'react'
// 3rd party libraries
import { motion } from 'framer-motion'
// Types
import { Memory, ScrapedFunerals } from '../../../types/types'
// Styles
import s from '../../../styles/pages/RecentFunerals.module.scss'
// Components
import ImgLeftCard from '../../cards/imgLeftCard/ImgLeftCard'
import { Text } from '../../core/text/Text'
import helperFunctions from '../../../utils/helperFunctions'

const FuneralCards = ({ cards, info, openModal, setFuneral }) => {
    const container = {
        hidden: {
            opacity: 0,
        },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    }

    const getStreamExternalLink = (streamLink: string) => {
        const externalLink = streamLink?.includes('https' || 'http')
        if (externalLink) return streamLink
        return `https://${streamLink}`
    }

    if (cards.length > 0) {
        return (
            <motion.div
                className={s.imgLeft}
                variants={container}
                initial={'hidden'}
                animate="show"
            >
                {cards.map((data: Memory | ScrapedFunerals, i: number) => {
                    const date: string = helperFunctions.getDate(
                        data.announcements.funeral.funeralDate,
                        true
                    )

                    if (!data.scraped) {
                        const m = data as Memory

                        const to = [
                            {
                                to: `/memories/${m.objectID}`,
                                label: 'Lesa meira',
                            },
                        ]

                        if (m.announcements.funeral.streamLink) {
                            to.push({
                                to: getStreamExternalLink(
                                    m.announcements.funeral.streamLink
                                ),
                                label: 'Hlekkur á streymi',
                            })
                        }

                        return (
                            <div key={i}>
                                <ImgLeftCard
                                    memory={m}
                                    page="funeral"
                                    buttons={to}
                                    infoText={m.announcements.funeral.text}
                                    funeralInfo={date}
                                />
                            </div>
                        )
                    } else {
                        data = data as ScrapedFunerals

                        const to = [
                            {
                                id: data.fullName,
                                onClick: () => {
                                    setFuneral(data)
                                    openModal()
                                },
                                to: '',
                                label: 'Stofna minningarsíðu',
                            },
                        ]

                        if (data.announcements.funeral.streamLink) {
                            to.push({
                                id: '',
                                onClick: null,
                                to: getStreamExternalLink(
                                    data.announcements.funeral.streamLink
                                ),
                                label: 'Hlekkur á streymi',
                            })
                        }

                        return (
                            <div key={i}>
                                <ImgLeftCard
                                    memory={data}
                                    page="funeral"
                                    buttons={to}
                                    infoText={data.announcements.funeral.text}
                                    funeralInfo={date}
                                    isScraped={true}
                                />
                            </div>
                        )
                    }
                })}
            </motion.div>
        )
    } else {
        return (
            <Text variant="p" className={s.subText}>
                Engar útfarir {info}
            </Text>
        )
    }
}

export default FuneralCards
